import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import styles from "./AccountDetail.module.css";
import { Spinner } from "../../Common";
import { getMcbvendorDetails } from "../../api";
import { getPersonalDetails, getContactDetails, getVendorDetails,infoSteps} from "../../utils/utils";
import info from "../../../src/public/images/info.svg"

const BasicDetails = ({ userDetails, featureAccess }) => {
  const { writeAccess } = featureAccess;
  const [activeKey, setActiveKey] = useState("0");
  const [vendorData, setVendorData] = useState(null);
  const [vendorLoading, setVendorLoading] = useState(false);

  const handleToggle = async (key) => {
    setActiveKey((prevKey) => (prevKey === key ? null : key));

    if (key === "1" && !vendorData) {
      try {
        setVendorLoading(true);
        const res = await getMcbvendorDetails(userDetails.userId);

        if (res?.data?.status === 200) {
          setVendorData(res.data.data);
        }
      } catch (err) {
      } finally {
        setVendorLoading(false);
      }
    }
  };

  if (!userDetails) {
    return (
      <div className={styles.noData}>
        <Spinner />
      </div>
    );
  }

  const personalDetails = getPersonalDetails(userDetails);
  const contactDetails = getContactDetails(userDetails);
  const vendorDetails = getVendorDetails(vendorData);

  return (
    <Accordion activeKey={activeKey} className={styles.accordionContainer}>
      <Accordion.Item eventKey="0">
        <Accordion.Header onClick={() => handleToggle("0")}>
          Basic Details
        </Accordion.Header>

        <Accordion.Body className={styles.accordionBody}>
          <div className={styles.globalAccountContainer}>
            <div className={styles.detailsRow}>
              <div className={styles.detailsSection}>
                <h3 className={styles.sectionTitle}>Personal Information</h3>
                <table className={styles.detailsTable}>
                  <tbody>
                    {personalDetails.map((item, index) => (
                      <tr key={index}>
                        <td className={styles.labelColumn}>{item.label}:</td>
                        <td className={styles.valueColumn}>
                          <div className={styles.inlineInfoWrapper}>
                            {item.value || "--"}
                            {item.showInfo && (
                              <span className={styles.infoHoverWrapper}>
                                <img
                                  src={info}
                                  alt="info"
                                  className={styles.infoIcon}
                                />

                                <span className={styles.infoText}>
                                  {Object.entries(infoSteps).map(
                                    ([key, value]) => (
                                      <div
                                        key={key}
                                        className={styles.infoStepItem}
                                      >
                                        <strong>{key}</strong>: {value}
                                      </div>
                                    ),
                                  )}
                                </span>
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className={styles.detailsSection}>
                <h3 className={styles.sectionTitle}>Contact Information</h3>
                <table className={styles.detailsTable}>
                  <tbody>
                    {contactDetails.map((item, index) => (
                      <tr key={index}>
                        <td className={styles.labelColumn}>{item.label}:</td>
                        <td
                          className={
                            item.label === "Address"
                              ? styles.addressColumn
                              : styles.valueColumn
                          }
                        >
                          {item.value || "--"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Accordion.Body>
      </Accordion.Item>
      {writeAccess && (
        <Accordion.Item eventKey="1" style={{ marginTop: "20px" }}>
          <Accordion.Header onClick={() => handleToggle("1")}>
            Vendor Details
          </Accordion.Header>

          <Accordion.Body className={styles.accordionBody}>
            <div className={styles.globalAccountContainer}>
              <div className={styles.detailsRow}>
                <div
                  className={`${styles.detailsSection} ${styles.singleColumn}`}
                >
                  {vendorLoading ? (
                    <Spinner />
                  ) : (
                    <table className={styles.detailsTable}>
                      <tbody>
                        {vendorDetails.map((item, index) => (
                          <tr key={index}>
                            <td className={styles.labelColumn}>
                              {item.label}:
                            </td>
                            <td className={styles.valueColumn}>
                              {item.value || "--"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      )}
    </Accordion>
  );
};

export default BasicDetails;
